import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import handlePushState from "../../misc/handlePushState";

export default function StepLink({ step, htmlId, label = null }) {
  const {
    car,
    endpoints,
    strings,
    setCurrentStep,
    validSteps,
  } = useContext(CarOrderingContext)

  const changeToNextStep = () => {
    if (! validSteps.includes(step.id)) {
      return
    }

    setCurrentStep(step)

    handlePushState(endpoints.order, step.id, car.slug)
  }

  return (
    <a
      role='button'
      onClick={changeToNextStep}
      id={htmlId}
      className='config-overview-bar__next-button'
      data-step-is-valid={validSteps.includes(step.id)}
    >
      {label !== null ? label : strings.navigation?.next ?? 'Næste'}
    </a>
  )
}

